export function avatarHue(externalId: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < externalId.length; i++) {
    hash ^= externalId.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash % 360;
}

export function avatarInitials(displayName: string): string {
  if (!displayName) return '?';
  // YouTube display names vêm prefixados com "@" — strip pra não virar inicial.
  const cleaned = displayName.replace(/^@+/, '').trim();
  if (!cleaned) return '?';
  const parts = cleaned.split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
  }
  return parts[0]!.slice(0, 2).toUpperCase();
}

export function avatarColors(externalId: string): { bg: string; fg: string } {
  const hue = avatarHue(externalId);
  return {
    bg: `hsl(${hue}, 30%, 22%)`,
    fg: `hsl(${hue}, 60%, 75%)`,
  };
}
